export default __webpack_public_path__ + "static/183-95ee0556e61503c9c4c6677c7e6af481.jpg";